import type { PouchOperationActivityType } from '../enums/PouchOperationActivityType'

export class DriverPouchOperationEntity {
  id?: string
  amount?: number
  activityType?: PouchOperationActivityType
  startDate?: string | null
  orderId?: string | null
  orderReferenceCode?: string | null
  userId?: string | null
  userDisplayName?: string | null
  roundDifference?: number
  shipmentOrderCreatedAt?: string | null
}
